import { useLocation } from 'react-router-dom';

/*
 * A detail page sits behind a popup route (see DynamicPopupRoute) without
 * ever unmounting, so its data-fetching children (DetailHeaderCard,
 * DetailViewV1, ActivityNotesCard, ...) only refetch when their own deps
 * (moduleName/id) change — never on their own after a popup mutates the
 * record. On a successful popup submit, DynamicPopupRoute re-enters this same
 * location with a fresh `refreshTimestamp` in its state; this hook reads that
 * value so it can be passed as `refreshKey` to those children, putting it in
 * their fetch effect's dependency array to force one refetch. The older
 * `__refreshedAt` key remains a fallback for existing callers.
 */
export function useRecordRefresh() {
  const location = useLocation();
  return location.state?.refreshTimestamp ?? location.state?.__refreshedAt ?? 0;
}
